import PropTypes from "prop-types";
import TableLoader from "../../../../utils/TableLoader";
import PaginationComponent from "../../../../utils/PaginationComponent";
import defaultImage from "../../../../utils/DefaultImage";
import CatalogFilterSection from "./CatalogFilterSection";
import SelectedWinesOrderSection from "./SelectedWinesOrderSection";

const NewWinesCatalog = ({
    isVisible,
    openDropdown,
    setOpenDropdown,
    dropdownRef,
    selectedNation,
    setSelectedNation,
    handleNationFilter,
    nations,
    selectedRegion,
    setSelectedRegion,
    handleRegionFilter,
    regions,
    selectedGrape,
    setSelectedGrape,
    handleGrapeFilter,
    grapeVarieties,
    selectedProductType,
    setSelectedProductType,
    handleProductTypeFilter,
    productTypes,
    handleApplyFilters,
    handleResetFilters,
    searchNome,
    setSearchNome,
    allWinesData,
    isWinesLoading,
    selectedCatalogWineIds = [],
    existingWineIds = [],
    handleToggleSelectCatalogWine,
    catalogPage,
    totalCatalogWines,
    catalogRowsPerPage,
    setCatalogPage,
    setCatalogRowsPerPage,
    selectedWines,
    handleDirectQuantityInput,
    handleRemoveWine,
    cleanImageUrl,
    canRemove = true
}) => {
    return (
        <div className={`w-full bg-[#FBFBFB] border-[2px] border-[#8B24332B] p-5 rounded-xl shadow space-y-4 ${isVisible ? "block" : "hidden"}`}>
            {/* Modular Filter Section */}
            <CatalogFilterSection
                openDropdown={openDropdown}
                setOpenDropdown={setOpenDropdown}
                dropdownRef={dropdownRef}
                selectedNation={selectedNation}
                setSelectedNation={setSelectedNation}
                handleNationFilter={handleNationFilter}
                nations={nations}
                selectedRegion={selectedRegion}
                setSelectedRegion={setSelectedRegion}
                handleRegionFilter={handleRegionFilter}
                regions={regions}
                selectedGrape={selectedGrape}
                setSelectedGrape={setSelectedGrape}
                handleGrapeFilter={handleGrapeFilter}
                grapeVarieties={grapeVarieties}
                selectedProductType={selectedProductType}
                setSelectedProductType={setSelectedProductType}
                handleProductTypeFilter={handleProductTypeFilter}
                productTypes={productTypes}
                handleApplyFilters={handleApplyFilters}
                handleResetFilters={handleResetFilters}
                searchNome={searchNome}
                setSearchNome={setSearchNome}
            />

            {/* Catalog Table */}
            <div className="overflow-x-auto rounded-lg border border-[#8B2433]/15">
                <table className="w-full text-left wine_table">
                    <thead>
                        <tr className="border-b border-[#8B2433]/30 bg-white">
                            <th className="py-3 px-4 poppins-medium text-[#6B6B6B] text-sm w-10"></th>
                            <th className="py-3 px-4 poppins-medium text-[#6B6B6B] text-sm">Immagine</th>
                            <th className="py-3 px-4 poppins-medium text-[#6B6B6B] text-sm">Nome</th>
                            <th className="py-3 px-4 poppins-medium text-[#6B6B6B] text-sm">Nazione</th>
                            <th className="py-3 px-4 poppins-medium text-[#6B6B6B] text-sm">Regione</th>
                            <th className="py-3 px-4 poppins-medium text-[#6B6B6B] text-sm">Vitigno</th>
                            <th className="py-3 px-4 poppins-medium text-[#6B6B6B] text-sm">Tipologia</th>
                        </tr>
                    </thead>
                    {isWinesLoading ? (
                        <TableLoader />
                    ) : (
                        <tbody>
                            {allWinesData && allWinesData.length > 0 ? (
                                allWinesData.map((wine) => {
                                    const isExisting = existingWineIds.some((id) => String(id) === String(wine.id));
                                    const isSelected = selectedCatalogWineIds.some((id) => String(id) === String(wine.id));
                                    return (
                                        <tr
                                            key={wine.id}
                                            className={`border-b border-[#8B2433]/10 ${
                                                isExisting ? "bg-gray-50/70" : "bg-white hover:bg-gray-50/50"
                                            }`}
                                        >
                                            <td className="py-2.5 px-4">
                                                <input
                                                    type="checkbox"
                                                    checked={isExisting ? false : isSelected}
                                                    disabled={isExisting}
                                                    onChange={() => !isExisting && handleToggleSelectCatalogWine(wine)}
                                                    className={`w-4 h-4 rounded transition-all ${
                                                        isExisting
                                                            ? "cursor-not-allowed opacity-40 accent-gray-400"
                                                            : "cursor-pointer accent-[#8B2433]"
                                                    }`}
                                                    title={isExisting ? "Questo vino è già presente nella proposta" : "Seleziona vino"}
                                                />
                                            </td>
                                            <td className="py-2.5 px-4">
                                                <div className="w-[45px] h-[50px] bg-white p-1 rounded-md border border-[#8B2433]/20 flex items-center justify-center">
                                                    <img
                                                        src={cleanImageUrl(wine.image) || defaultImage}
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = defaultImage;
                                                        }}
                                                        alt={wine.name}
                                                        className="h-full w-full object-contain"
                                                    />
                                                </div>
                                            </td>
                                            <td className="py-2.5 px-4 poppins-medium text-[#303030] text-sm">
                                                <div className="flex items-center gap-2">
                                                    <div className="relative group inline-block max-w-[220px]">
                                                        <span className="block truncate select-text cursor-text">
                                                            {wine.name}
                                                        </span>
                                                        <div className="absolute opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-[70] bottom-full left-0 mb-2 w-max max-w-[320px] bg-[#303030] text-white text-xs rounded-lg py-2 px-3 shadow-xl whitespace-normal break-words select-text pointer-events-auto">
                                                            {wine.name}
                                                            <div className="absolute top-full left-4 border-4 border-transparent border-t-[#303030]"></div>
                                                        </div>
                                                    </div>
                                                    {isExisting && (
                                                        <span className="inline-flex items-center justify-center px-2.5 py-[2px] text-[11px] font-medium tracking-wide uppercase rounded-md border bg-emerald-50 text-emerald-800 border-emerald-200 shrink-0">
                                                            Già presente
                                                        </span>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="py-2.5 px-4 poppins-regular text-gray-600 text-sm">
                                                {wine.nation || "N/A"}
                                            </td>
                                            <td className="py-2.5 px-4 poppins-regular text-gray-600 text-sm">
                                                {wine.region || "N/A"}
                                            </td>
                                            <td className="py-2.5 px-4 poppins-regular text-gray-600 text-sm">
                                                {wine.grape_variety || wine.vitigno || "N/A"}
                                            </td>
                                            <td className="py-2.5 px-4 poppins-regular text-gray-600 text-sm">
                                                {wine.product_type || wine.type || "N/A"}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={7} className="text-center py-6 text-gray-500 poppins-regular text-sm bg-white">
                                        Nessun vino trovato
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>
            </div>

            {/* Catalog Pagination */}
            {allWinesData && allWinesData.length > 0 && (
                <PaginationComponent
                    page={catalogPage}
                    totalPages={totalCatalogWines}
                    rowsPerPage={catalogRowsPerPage}
                    setPage={setCatalogPage}
                    setRowsPerPage={setCatalogRowsPerPage}
                />
            )}

            {/* Selected Wines Order Details Section */}
            <SelectedWinesOrderSection
                selectedWines={selectedWines}
                handleDirectQuantityInput={handleDirectQuantityInput}
                handleRemoveWine={handleRemoveWine}
                cleanImageUrl={cleanImageUrl}
                canRemove={canRemove}
            />
        </div>
    );
};

NewWinesCatalog.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    openDropdown: PropTypes.string,
    setOpenDropdown: PropTypes.func.isRequired,
    dropdownRef: PropTypes.object,
    selectedNation: PropTypes.array.isRequired,
    setSelectedNation: PropTypes.func.isRequired,
    handleNationFilter: PropTypes.func.isRequired,
    nations: PropTypes.array.isRequired,
    selectedRegion: PropTypes.array.isRequired,
    setSelectedRegion: PropTypes.func.isRequired,
    handleRegionFilter: PropTypes.func.isRequired,
    regions: PropTypes.array.isRequired,
    selectedGrape: PropTypes.array.isRequired,
    setSelectedGrape: PropTypes.func.isRequired,
    handleGrapeFilter: PropTypes.func.isRequired,
    grapeVarieties: PropTypes.array.isRequired,
    selectedProductType: PropTypes.array.isRequired,
    setSelectedProductType: PropTypes.func.isRequired,
    handleProductTypeFilter: PropTypes.func.isRequired,
    productTypes: PropTypes.array.isRequired,
    handleApplyFilters: PropTypes.func.isRequired,
    handleResetFilters: PropTypes.func.isRequired,
    searchNome: PropTypes.string,
    setSearchNome: PropTypes.func.isRequired,
    allWinesData: PropTypes.array.isRequired,
    isWinesLoading: PropTypes.bool.isRequired,
    selectedCatalogWineIds: PropTypes.array,
    existingWineIds: PropTypes.array,
    handleToggleSelectCatalogWine: PropTypes.func,
    catalogPage: PropTypes.number.isRequired,
    totalCatalogWines: PropTypes.number.isRequired,
    catalogRowsPerPage: PropTypes.number.isRequired,
    setCatalogPage: PropTypes.func.isRequired,
    setCatalogRowsPerPage: PropTypes.func.isRequired,
    selectedWines: PropTypes.array,
    handleDirectQuantityInput: PropTypes.func,
    handleRemoveWine: PropTypes.func,
    cleanImageUrl: PropTypes.func.isRequired,
    canRemove: PropTypes.bool
};

export default NewWinesCatalog;

